import request from '@/router/axios';

const urlPrefix = '/bizwage'

/**
 * 获取记录数据表头
 * @param data
 */
export function list(data) {
  return request({
    url: urlPrefix + '/financialStatements/list',
    method: 'post',
    data
  });
}

/**
 * 获取记录数据表头
 * @param data
 */
export function down(data) {
  return request({
    url: urlPrefix + '/financialStatements/down',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  });
}

/**
 * 获取记录数据表头
 * @param data
 */
export function selectCus(data) {
  return request({
    url: urlPrefix + '/financialStatements/selectCus',
    method: 'post',
    data
  });
}
